import { render, staticRenderFns } from "./AddGallery.vue?vue&type=template&id=07f3f3a2&scoped=true"
import script from "./AddGallery.vue?vue&type=script&lang=js"
export * from "./AddGallery.vue?vue&type=script&lang=js"
import style0 from "./AddGallery.vue?vue&type=style&index=0&id=07f3f3a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f3f3a2",
  null
  
)

export default component.exports